import { Component, OnInit } from '@angular/core';
import {Slider} from '../../models/slider';
import {Router} from '@angular/router';
import {SliderService} from '../../services/slider.service';
import {BaseService} from '../../base.service';
import { ContractsService } from '../../services/contracts.service';
import { ContractListItem } from '../../models/contractListItem';
import { ContractListItemSource } from '../../models/contractListItemSource';
import { PropertyService } from '../../services/property.service';
import { PropertyListItem } from '../../models/propertyListItem';
import { t } from '@angular/core/src/render3';

@Component({
  selector: 'app-property-list',
  templateUrl: './property-list.component.html',
  styleUrls: []
})
export class PropertyListComponent implements OnInit {

  private titleComponent: string;
  private titlePanel: string;
  private properties:PropertyListItem[] = [];
  private sliderId: number;
  
  total = 10000000;
  bigCurrentPage: number = 1;
  maxSize: number = 5;
  size: number = 10;
  page: number = 1;
  status: string = '';
  
  filter_dni:string = "";
  filter_ruc:string = "";

  constructor(
    private router: Router,
    private service: PropertyService,
    private baseService: BaseService
  ) {}

  ngOnInit() {
    this.titleComponent = 'Propiedades';
    this.titlePanel = 'Lista de propiedades';
    this.baseService.changedComponentName(this.titleComponent);

    this.list(0);
  }

  list( page:number = 0 , dni:string = "" , ruc:string = "") {
    this.service.getAll(page , dni , ruc , this.size ).subscribe(d => {
      console.log(d);
      //45864334
      //45878206
      if (d) {
        this.properties = [];
        let data:any = d;
        let pProperties:PropertyListItem[] = data.content;
        pProperties.map( r => {
          this.properties.push( {
            address: r.address,
            creationDate: r.creationDate,
            dni: r.dni,
            fullName: r.fullName,
            id: r.id,
            ownerType: r.ownerType,
            propertyDetails: r.propertyDetails,
            propertyName: r.propertyName,
            razonSocial: r.razonSocial,
            rentFullProperty: r.rentFullProperty,
            ruc: r.ruc,
            status: r.status,
          } );
        });
        this.total = data.totalElements;
        this.page = data.number;

      }
    });
  }

  get(event, id: number) {
    const link = ['/dashboard/properties', id];
    this.router.navigate(link);
  }


  pageChanged(event: any): void {
    this.list( event.page -1 ,this.filter_dni,this.filter_ruc);
  }


  filtrar(): void{
    this.list(0,this.filter_dni,this.filter_ruc);

  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/property/property-list.component.ts